// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-favorite {\n  filter: drop-shadow(0 0 1px #f59e0b);\n}\n", ""]);
// Exports
module.exports = exports;
